import { FC, useMemo } from 'react';
import classnames from 'classnames';

import { FormItem, SelectField, TextField } from 'componets/form';
import { SettingsCard } from './SettingsCard';

import { useAppSelector, useTranslate } from 'hooks';

import { Rules } from 'utils/constants';
import { selectCountries, selectUserSettings } from 'selectors';
import { Country } from 'models';

import s from './index.module.scss';

export const SettingsAddressCard: FC = () => {
	const { addressText, countryText, cityText, addressLabelSettingsText, zipCodeText } =
		useTranslate([
			'addressText',
			'countryText',
			'cityText',
			'addressLabelSettingsText',
			'zipCodeText',
		]);

	const countries = useAppSelector(selectCountries);
	const settings = useAppSelector(selectUserSettings);

	const countriesOptions = useMemo(() => {
		const currentCountry =
			countries?.find((item) => +item.id === +settings.country_id) || ({} as Country);

		return countries
			?.filter((item) => item.activeForRegistration || item.id === currentCountry.id)
			.map((item) => {
				return {
					label: item.label,
					value: item.id,
				};
			});
	}, [countries, settings.country_id]);

	return (
		<SettingsCard title={addressText}>
			<div className={classnames(s.contentRow, s.addressRow)}>
				<FormItem name="country_id" rules={[Rules.REQUIRED_SELECT]} className={s.addressInput}>
					<SelectField options={countriesOptions} placeholder={countryText} isFilter />
				</FormItem>

				<FormItem
					name="city"
					rules={[Rules.REQUIRED, Rules.MAX_LENGTH('city', 50)]}
					className={s.input}
				>
					<TextField label={cityText} />
				</FormItem>
			</div>

			<div className={classnames(s.contentRow, s.addressRow)}>
				<FormItem
					name="address"
					rules={[Rules.REQUIRED, Rules.MAX_LENGTH('address', 255)]}
					className={s.addressInput}
				>
					<TextField label={addressLabelSettingsText} />
				</FormItem>

				<FormItem
					name="zip"
					rules={[Rules.REQUIRED, Rules.MAX_LENGTH('zip', 20)]}
					className={s.input}
				>
					<TextField label={zipCodeText} />
				</FormItem>
			</div>
		</SettingsCard>
	);
};
